import { render } from "./InvitationPopup.vue?vue&type=template&id=2362c3aa&scoped=true"
import script from "./InvitationPopup.vue?vue&type=script&lang=js"
export * from "./InvitationPopup.vue?vue&type=script&lang=js"

import "./InvitationPopup.vue?vue&type=style&index=0&id=2362c3aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2362c3aa"]])

export default __exports__